export const stripFormattingFromPhoneNumber = (phoneNumber: string) =>
  phoneNumber.replaceAll(/[()\- ]/g, '');
